import { trigger,state, animate, transition, style } from '@angular/animations';
import { Component, EventEmitter, Input, Output, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./terms.component.scss'],
  animations: [
    trigger('popup', [
      state('open', style({
        opacity: 1,
        transform: 'scale(1)'
      })),
      state('closed', style({
        opacity: 0,
        transform: 'scale(0)'
      })),
      transition('open <=> closed', [
        animate('0.3s ease-in-out')
      ]),
    ])
  ]
})
export class TermsComponent {

  private $appData: Subscription;
  data: any = {}

  popup:any = null;
  focusableElements:any =  null;
  firstFocusableElement:any = null;
  lastFocusableElement:any = null;

  //-- CONSTRUCTOR -----------------------------------------------------|
  
  constructor(private apiService: ApiService, private appService: AppService) {
    this.$appData = this.apiService.$appData.subscribe(data => { this.applyValues(data); });      
  }

  //-- UTILITY METHODS -------------------------------------------------|

  applyValues(res: any) {
    this.data = res;
  }

  //-- VARIABLES -------------------------------------------------------|

  @Output() goClose = new EventEmitter<number>();
  @Input() showTerms = false;


  //-- EVENTS ----------------------------------------------------------|

  onClose() {
    this.goClose.emit();
    document.getElementById("info-terms").focus()
  }

  //--------------------------------------------------------------------|

  //-- INITIALIZE ------------------------------------------------------|
    
  ngOnInit() {
    const data = this.apiService.getData();
    this.applyValues(data);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['showTerms']) {
      this.onShowTermsChange(changes['showTerms'].currentValue);
    }
  }

  trapFocus(event: KeyboardEvent) {
    
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        // Shift + Tab
        if (document.activeElement === this.firstFocusableElement) {
          event.preventDefault();
          (this.lastFocusableElement as HTMLElement).focus();
        }
      } else {
        // Tab
        if (document.activeElement === this.lastFocusableElement) {
          event.preventDefault();
          (this.firstFocusableElement as HTMLElement).focus();
        }
      }
    } else if (event.key === 'Escape') {
      this.onClose();
    }
  }

  onShowTermsChange(show: boolean) {
    if (show) {
      this.trapFocus = this.trapFocus.bind(this);

      this.popup = document.getElementById('terms');
      this.focusableElements = this.popup.querySelectorAll('a, button, input, [tabindex="0"]');
      this.firstFocusableElement = this.focusableElements[0];
      this.firstFocusableElement.focus()
      this.lastFocusableElement = this.focusableElements[this.focusableElements.length - 1];

      document.addEventListener('keydown', this.trapFocus); 
    } else {
      document.removeEventListener('keydown', this.trapFocus);
      // document.getElementById("footnote1").focus()
    }
  }

  //-- DESTORY ---------------------------------------------------------|

  ngOnDestroy() {
    if (this.$appData) { this.$appData.unsubscribe(); }
  }

  //--------------------------------------------------------------------|


}
